// for friendStats
export const SET_FRIEND_STATS = 'SET_FRIEND_STATS';
export const GET_FRIEND_STATS = 'GET_FRIEND_STATS';

// for friendActivity
export const SET_FRIEND_ACTIVITY = 'SET_FRIEND_ACTIVITY';
export const GET_FRIEND_ACTIVITY = 'GET_FRIEND_ACTIVITY';

// for friendBadges
export const GET_FRIEND_BADGES = 'GET_FRIEND_BADGES';
export const SET_FRIEND_BADGES = 'SET_FRIEND_BADGES';
export const SET_IS_LOADING_FRIEND_BADGES = 'SET_IS_LOADING_FRIEND_BADGES';

// for friend scoring history
export const SET_FRIEND_SCORING_HISTORY = 'SET_FRIEND_SCORING_HISTORY';
export const GET_FRIEND_SCORING_HISTORY = 'GET_FRIEND_SCORING_HISTORY';

// for friend header
export const SET_FRIEND_HEADER = 'SET_FRIEND_HEADER';
export const GET_FRIEND_HEADER = 'GET_FRIEND_HEADER';
// for friend profile
export const SET_FRIEND_PROFILE = 'SET_FRIEND_PROFILE';
export const GET_FRIEND_PROFILE = 'GET_FRIEND_PROFILE';
